var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal student-completion-modal",
      attrs: {
        maximized: _vm.maximized,
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true,
        value: _vm.studentCompletionModal,
        "content-css": { width: "1200px", maxWidth: "100%", minHeight: "75vh" }
      },
      on: {
        hide: function($event) {
          _vm.closeModal("studentCompletion")
        }
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-certificate" } }),
                  _vm._v(" Student Completion Report\n      ")
                ],
                1
              ),
              _c("q-icon", {
                staticClass: "gt-sm",
                attrs: { size: "20px", name: "filter_none" },
                nativeOn: {
                  click: function($event) {
                    _vm.toggleMaximized()
                  }
                }
              }),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.closeModal("studentCompletion")
                  }
                }
              })
            ],
            1
          ),
          _c(
            "q-stepper",
            {
              ref: "stepper",
              attrs: { "no-header-navigation": "" },
              model: {
                value: _vm.currentStep,
                callback: function($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep"
              }
            },
            [
              _c(
                "q-step",
                {
                  attrs: {
                    default: "",
                    name: "start",
                    title: "Start",
                    "done-icon": "check",
                    subtitle: ""
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c("div", { staticClass: "absolute-center" }, [
                        _vm._v(
                          "\n          This report shows all the students completed for a given date range.\n        "
                        )
                      ])
                    ]
                  )
                ]
              ),
              _c(
                "q-step",
                {
                  attrs: {
                    name: "course",
                    order: "3",
                    title: "Pick a course",
                    "done-icon": "check",
                    subtitle: ""
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c("div", { staticClass: "absolute-center" }, [
                        _vm._v(
                          "\n          This report shows all the students completed for a given date range.\n        "
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c(
                        "div",
                        { staticClass: "absolute-center large-width" },
                        [
                          _c("q-select", {
                            attrs: {
                              clearable: "",
                              options: _vm.courseOptions,
                              value: _vm.studentCompletionForm.COURSE_ID,
                              placeholder: _vm.courseDropdownLabel,
                              disable: _vm.disableCourseDropdown
                            },
                            on: {
                              input: function(value) {
                                return _vm.updateStudentCompletionForm({
                                  field: "COURSE_ID",
                                  value: value
                                })
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _c(
                "q-step",
                {
                  attrs: {
                    name: "date",
                    order: "4",
                    title: "Choose a date range",
                    "done-icon": "check",
                    subtitle: ""
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c("div", { staticClass: "absolute-center" }, [
                        _vm._v(
                          "\n            Please choose a date range to search for student completions.\n        "
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "relative-position layout-padding" },
                    [
                      _c("div", { staticClass: "sl-row sl-vp " }, [
                        _c(
                          "div",
                          { staticClass: "sl-col-6" },
                          [
                            _c("q-datetime", {
                              staticClass: "medium-width  float-right",
                              attrs: {
                                clearable: "",
                                "stack-label": "Start Date",
                                value: _vm.studentCompletionForm.START_DATE
                              },
                              on: {
                                input: function(value) {
                                  return _vm.updateStudentCompletionForm({
                                    field: "START_DATE",
                                    value: value
                                  })
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "sl-col-6" },
                          [
                            _c("q-datetime", {
                              staticClass: "medium-width",
                              attrs: {
                                clearable: "",
                                "stack-label": "End Date",
                                value: _vm.studentCompletionForm.END_DATE,
                                max: _vm.maxEndDate
                              },
                              on: {
                                input: function(value) {
                                  return _vm.updateStudentCompletionForm({
                                    field: "END_DATE",
                                    value: value
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]
              ),
              _c(
                "q-step",
                {
                  staticClass: "no-padding",
                  attrs: {
                    name: "review",
                    order: "5",
                    title: "Review",
                    "done-icon": "check",
                    subtitle: ""
                  }
                },
                [
                  _vm.studentCompletionList.length <= 0
                    ? _c(
                        "div",
                        { staticClass: "relative-position layout-padding" },
                        [
                          _c("div", { staticClass: "absolute-center" }, [
                            _vm._v(
                              "\n            No students have completed the course during the period of " +
                                _vm._s(_vm.startDate) +
                                " to  " +
                                _vm._s(_vm.endDate) +
                                ".\n        "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.studentExceptionList.length <= 0 &&
                  _vm.studentCompletionList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "relative-position layout-padding" },
                        [
                          _c("div", { staticClass: "absolute-center" }, [
                            _vm._v(
                              "\n            No student exceptions have been found during the period of " +
                                _vm._s(_vm.startDate) +
                                " to  " +
                                _vm._s(_vm.endDate) +
                                ". Please generate the report.\n        "
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm.studentExceptionList.length >= 0 &&
                  _vm.studentCompletionList.length > 0
                    ? _c(
                        "div",
                        [
                          _c("class-details-modal"),
                          _c(
                            "q-list",
                            _vm._l(_vm.studentExceptionList, function(
                              item,
                              index
                            ) {
                              return _c(
                                "q-item",
                                { key: index, attrs: { multiline: "" } },
                                [
                                  _c(
                                    "q-item-side",
                                    [
                                      _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            icon: "fa fa-external-link",
                                            outline: "",
                                            color: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.select(item)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "q-tooltip",
                                            {
                                              attrs: {
                                                anchor: "bottom middle",
                                                self: "top middle",
                                                offset: [10, 10]
                                              }
                                            },
                                            [_vm._v("View")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "", lines: "1" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.FIRST_NAME +
                                                " " +
                                                item.MIDDLE_NAME +
                                                " " +
                                                item.LAST_NAME
                                            ) +
                                              " - " +
                                              _vm._s(item.DRIVERS_LICENSE)
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-item-tile",
                                        { attrs: { sublabel: "", lines: "2" } },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              "Class ID - " +
                                                _vm._s(item.CLASS_ID)
                                            )
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-item-side",
                                    {
                                      staticClass: "text-red",
                                      attrs: { right: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.exceptionInfo) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            })
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _c(
                "q-inner-loading",
                { attrs: { visible: _vm.loading } },
                [
                  _c("q-spinner-puff", {
                    attrs: { color: "primary", size: "70" }
                  }),
                  _c("span", [_vm._v("Running Report..")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "q-toolbar",
            {
              staticClass: "sl-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.currentStep === "review" && _vm.selectedStudents.length > 0
                ? _c("q-btn", {
                    attrs: {
                      color: "red",
                      icon: "fa fa-trash",
                      label: "Remove Selected"
                    },
                    on: {
                      click: function($event) {
                        _vm.removeSelectedStudents()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n    "),
              _vm.currentStep !== "start"
                ? _c("q-btn", {
                    attrs: {
                      outline: "",
                      color: "red",
                      size: "md",
                      icon: "fa fa-rotate-left",
                      label: "Start Over"
                    },
                    nativeOn: {
                      click: function($event) {
                        _vm.resetReport()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n    "),
              _c("q-toolbar-title"),
              _vm.currentStep !== "start"
                ? _c("q-btn", {
                    attrs: { color: "primary", flat: "", label: "Back" },
                    on: {
                      click: function($event) {
                        _vm.$refs.stepper.previous()
                      }
                    }
                  })
                : _vm._e(),
              _c("q-btn", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.currentStep !== "date" &&
                      _vm.currentStep !== "review",
                    expression:
                      "currentStep !== 'date' && currentStep !== 'review'"
                  }
                ],
                staticClass: "q-mx-md",
                attrs: {
                  flat: "",
                  color: "primary",
                  disable: _vm.disableNext,
                  label: "Next"
                },
                on: {
                  click: function($event) {
                    _vm.$refs.stepper.next()
                  }
                }
              }),
              _vm.currentStep === "date" || _vm.currentStep === "review"
                ? _c("q-btn", {
                    attrs: {
                      color: "green",
                      loading: _vm.loading,
                      disable: _vm.disableRun,
                      icon: _vm.runIcon,
                      label: _vm.runLabel
                    },
                    on: {
                      click: function($event) {
                        _vm.runReport()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n    "),
              _vm.currentStep === "review"
                ? _c("q-btn", {
                    attrs: {
                      color: "green",
                      loading: _vm.loading,
                      icon: "fa fa-gear",
                      label: "Generate"
                    },
                    on: {
                      click: function($event) {
                        _vm.generateReport()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" \n  ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }